var exports = {
  "_8": "xa15a2ab7--50408a--img",
  "DD": "xa15a2ab7--50408a--title",
  "p_": "xa15a2ab7--50408a--list",
  "nM": "xa15a2ab7--50408a--row",
  "Kk": "xa15a2ab7--50408a--icon",
  "ne": "xa15a2ab7--50408a--controls",
  "xh": "xa15a2ab7--50408a--controls-with-input",
  "aL": "xa15a2ab7--50408a--legal",
  "Hc": "xa15a2ab7--50408a--marketing",
  "nf": "xa15a2ab7--50408a--link",
};

module.exports = exports;
